module.exports = __webpack_public_path__ + "static/vouch-ab3e28442062679cb58720a24e88b0e5.png";